import { render, staticRenderFns } from "./TheCompanyForm.vue?vue&type=template&id=dc658102&scoped=true&lang=pug&"
import script from "./TheCompanyForm.vue?vue&type=script&lang=js&"
export * from "./TheCompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc658102",
  null
  
)

export default component.exports